const validDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const startOfDay = (date) => {
  const value = new Date(date);
  value.setHours(0, 0, 0, 0);
  return value;
};

const endOfDay = (date) => {
  const value = new Date(date);
  value.setHours(23, 59, 59, 999);
  return value;
};

export const formatCreated = (value) => {
  const date = validDate(value);
  if (!date) return null;
  return {
    date: new Intl.DateTimeFormat(undefined, {
      day: "2-digit", month: "short", year: "numeric",
    }).format(date),
    time: new Intl.DateTimeFormat(undefined, {
      hour: "numeric", minute: "2-digit",
    }).format(date),
    tooltip: `Created: ${new Intl.DateTimeFormat(undefined, {
      day: "numeric", month: "long", year: "numeric", hour: "numeric",
      minute: "2-digit", second: "2-digit",
    }).format(date)}\nUTC: ${new Intl.DateTimeFormat("en-GB", {
      timeZone: "UTC", day: "2-digit", month: "long", year: "numeric",
      hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
    }).format(date)}`,
  };
};

export const createdBounds = (preset, now = new Date(), custom = {}) => {
  const today = startOfDay(now);
  if (preset === "today") return { from: today, to: endOfDay(today) };
  if (preset === "yesterday") {
    const day = new Date(today); day.setDate(day.getDate() - 1);
    return { from: day, to: endOfDay(day) };
  }
  if (preset === "last_7_days" || preset === "last_30_days") {
    const days = preset === "last_7_days" ? 7 : 30;
    const from = new Date(today); from.setDate(from.getDate() - (days - 1));
    return { from, to: endOfDay(today) };
  }
  if (preset === "this_month") {
    const from = new Date(now.getFullYear(), now.getMonth(), 1);
    const to = endOfDay(new Date(now.getFullYear(), now.getMonth() + 1, 0));
    return { from, to };
  }
  if (preset === "previous_month") {
    const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const to = endOfDay(new Date(now.getFullYear(), now.getMonth(), 0));
    return { from, to };
  }
  if (preset === "custom") {
    return {
      from: validDate(custom.from),
      to: validDate(custom.to),
    };
  }
  return { from: null, to: null };
};

export const localInputToIso = (date, time, isEnd = false) => {
  if (!date) return "";
  const clock = time || (isEnd ? "23:59:59.999" : "00:00:00.000");
  const value = new Date(`${date}T${clock}`);
  return Number.isNaN(value.getTime()) ? "" : value.toISOString();
};

export const matchesCreatedRange = (value, bounds) => {
  const date = validDate(value);
  if (!date) return false;
  if (bounds.from && date < bounds.from) return false;
  if (bounds.to && date > bounds.to) return false;
  return true;
};

export const CREATED_LABELS = {
  any: "Any time",
  today: "Today",
  yesterday: "Yesterday",
  last_7_days: "Last 7 days",
  last_30_days: "Last 30 days",
  this_month: "This month",
  previous_month: "Previous month",
  custom: "Custom range",
};

export const createdFilterLabel = (preset, bounds) => {
  if (preset !== "custom") return CREATED_LABELS[preset] || "Any time";
  const format = (value) => value ? new Intl.DateTimeFormat(undefined, {
    day: "numeric", month: "short", year: "numeric",
  }).format(value) : null;
  const from = format(bounds.from);
  const to = format(bounds.to);
  if (from && to) return from === to ? from : `${from} – ${to}`;
  return from ? `From ${from}` : to ? `Until ${to}` : "Any time";
};
